export enum PondStatus {
  Active = 'active',
  Completed = 'completed',
}

export enum PondTab {
  Setting = 'cycle',
  Dashboard = 'dashboard',
  Food = 'food',
  Growth = 'growth',
  Water = 'water',
  DeadShrimp = 'dead_shrimp',
  Medicine = 'medicine',
  Cost = 'cost',
  Sales = 'sales',
  Transfer = 'transfer',
  Iot = 'iot',
  Topup = 'topup',
}

/**
 * Keys are the `features=` values the backend export endpoint accepts, and the
 * order here is the order the exported pages / sheets come out in.
 * Values are i18n keys for the checkbox labels (interpolated with `speciesName`).
 */
export const Feature = {
  food: 'pond:food',
  growth: 'pond:growth',
  waterquality: 'pond:water.quality',
  deadshrimp: 'layout:shrimpDie',
  medicine: 'pond:medical.supply',
  shrimpsales: 'layout:sellShrimp',
  cost: 'pond:cost',
}

export enum ExportFormat {
  Pdf = 'pdf',
  Xlsx = 'xlsx',
  Csv = 'csv',
}

/** Labels are file-format names, so they are not translated. */
export const EXPORT_FORMAT_LABEL: Record<ExportFormat, string> = {
  [ExportFormat.Pdf]: 'PDF',
  [ExportFormat.Xlsx]: 'Excel',
  [ExportFormat.Csv]: 'CSV',
}

export const EXPORT_FORMAT_ORDER = [ExportFormat.Pdf, ExportFormat.Xlsx, ExportFormat.Csv]

export enum SpeciesType {
  Shrimp = 1,
  Fish = 2,
}

export enum SpeciesName {
  Shrimp = 'กุ้ง',
  Fish = 'ปลา',
}

export enum PondSortBy {
  Issues = 'issues',
  Profit = 'profit',
  Name = 'name',
  CreatedAt = 'created_at',
}

export enum PondSortOrder {
  Asc = 'asc',
  Desc = 'desc',
}

export enum PondType {
  MonitoringPond = 'monitoring_pond',
  ActivePond = 'active_pond',
  InactivePond = 'inactive_pond',
}
export enum MoonPhase {
  NewMoon = 'new moon',
  WaxingCrescent = 'waxing crescent',
  FirstQuarter = 'first quarter',
  WaxingGibbous = 'waxing gibbous',
  FullMoon = 'full moon',
  WaningGibbous = 'waning gibbous',
  LastQuarter = 'last quarter',
  WaningCrescent = 'waning crescent',
}

export enum WeatherDescriptions {
  PartlyCloudyWithRain = 'partly cloudy with rain',

  PartlyCloudy = 'partly cloudy',
  Cloudy = 'cloudy',
  Mist = 'mist',
  BlowingSnow = 'blowing snow',
  Fog = 'fog',
  FreezingFog = 'freezing fog',

  Sunny = 'sunny',

  Clear = 'clear',

  PartlyCloudyNight = 'partly cloudy night',

  Thunderstorm = 'thundery outbreaks possible',

  ModerateRain = 'moderate rain',
  ModerateRainAtTimes = 'moderate rain at times',

  PatchyRainPossible = 'patchy rain possible',
  PatchySnowPossible = 'patchy snow possible',
  PatchySleetPossible = 'patchy sleet possible',
  PatchyFreezingDrizzlePossible = 'patchy freezing drizzle possible',
  PatchyLightDrizzle = 'patchy light drizzle',
  LightDrizzle = 'light drizzle',
  FreezingDrizzle = 'freezing drizzle',
  HeavyFreezingDrizzle = 'heavy freezing drizzle',
  PatchyLightRain = 'patchy light rain',
  LightRain = 'light rain',
  LightFreezingRain = 'light freezing rain',

  Overcast = 'overcast',
  Blizzard = 'blizzard',
  HeavyRainAtTimes = 'heavy rain at times',
  HeavyRain = 'heavy rain',
}

export const PondErrorCodes = {
  INITIAL_SHRIMP_COUNT_UPDATE_BLOCKED_BY_PARTIAL_TRANSFER:
    'initial.shrimp.count.updated.blocked.by.partial.transfer',
}
